import React from "react";
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Typography, Avatar, IconButton, Button, Stack,
} from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import LockIcon from "@mui/icons-material/Lock";

import { SECTION_COLORS } from "../../constants";
import { isBaseTier as isBaseLoyaltyTier } from "../../utils/loyaltyQualification";

const ViewTierDialog = ({ open, tier, onClose, onEditRequest }) => {
    if (!tier) return null;
    const isBaseTier = isBaseLoyaltyTier(tier);
    const rows = [
        { label: "Rang", value: tier.rank },
        { label: "Points minimum", value: tier.min_status_points?.toLocaleString("fr-FR") ?? "0" },
        { label: "Achats minimum", value: (tier.min_purchase_count ?? 0).toLocaleString("fr-FR") },
        { label: "Montant minimum", value: (tier.min_purchase_amount ?? 0).toLocaleString("fr-FR") },
        { label: "Marque", value: tier.brand },
        { label: "Identifiant", value: tier.id },
        { label: "Créé le", value: tier.created_at ? new Date(tier.created_at).toLocaleDateString("fr-FR") : "–" },
    ];

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ borderBottom: "2px solid #f1f3f5", px: 3, py: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box display="flex" alignItems="center" gap={1}>
                    <Avatar sx={{ width: 32, height: 32, background: SECTION_COLORS.tiers.gradient }}>
                        <EmojiEventsIcon sx={{ fontSize: 18 }} />
                    </Avatar>
                    <Box>
                        <Typography variant="h6" fontFamily="Montserrat, sans-serif" fontWeight={700} color="#1a1a2e" fontSize={16}>
                            {tier.name}
                        </Typography>
                        <Typography fontSize={11} color="text.secondary">Détail du niveau de fidélité</Typography>
                    </Box>
                </Box>
                <IconButton onClick={onClose} size="small"><CloseIcon /></IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: "24px !important", px: 3, pb: 2 }}>
                {/* Status banner */}
                <Box display="flex" alignItems="center" gap={1} mb={2.5} px={2} py={1.25}
                    sx={{
                        borderRadius: 2, bgcolor: tier.active ? "#f0fdf4" : "#fef2f2",
                        border: `1px solid ${tier.active ? "#86efac" : "#fca5a5"}`
                    }}>
                    {tier.active
                        ? <CheckCircleIcon sx={{ fontSize: 18, color: "#16a34a" }} />
                        : <CancelIcon sx={{ fontSize: 18, color: "#DC2626" }} />}
                    <Typography fontSize={13} fontWeight={600} color={tier.active ? "#16a34a" : "#DC2626"}>
                        {tier.active ? "Niveau actif" : "Niveau inactif"}
                    </Typography>
                    <Box sx={{ ml: "auto", px: 1.5, py: 0.5, borderRadius: 10, background: SECTION_COLORS.tiers.gradient }}>
                        <Typography fontSize={12} fontWeight={800} color="#fff">Rang {tier.rank}</Typography>
                    </Box>
                </Box>

                {isBaseTier && (
                    <Box display="flex" alignItems="center" gap={1} mb={2} px={2} py={1.25}
                        sx={{ borderRadius: 2, bgcolor: "#fef9c3", border: "1px solid #fde047" }}>
                        <LockIcon sx={{ fontSize: 16, color: "#854d0e" }} />
                        <Typography fontSize={12} fontWeight={600} color="#854d0e">
                            Niveau de base — non supprimable
                        </Typography>
                    </Box>
                )}
                <Stack spacing={1}>
                    {rows.map(({ label, value }) => (
                        <Box key={label} display="flex" alignItems="flex-start" justifyContent="space-between"
                            px={2} py={1} sx={{ borderRadius: 2, bgcolor: "#fafbfd", border: "1px solid #e8ecf1" }}>
                            <Typography fontSize={12} color="text.secondary" fontWeight={500} sx={{ minWidth: 140 }}>{label}</Typography>
                            <Typography fontSize={12} fontWeight={600} color="#1a1a2e" sx={{ textAlign: "right", wordBreak: "break-all" }}>{value}</Typography>
                        </Box>
                    ))}
                </Stack>
            </DialogContent>

            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e0e0e0", gap: 1 }}>
                <Button onClick={onClose} sx={{ color: "text.secondary", textTransform: "none" }}>Fermer</Button>
                <Button variant="contained" onClick={() => { onClose(); onEditRequest(tier); }}
                    startIcon={<EditIcon />}
                    sx={{
                        background: SECTION_COLORS.tiers.gradient, textTransform: "none", borderRadius: 2, fontWeight: 600, px: 3,
                        "&:hover": { boxShadow: `0 4px 16px ${SECTION_COLORS.tiers.main}40` }
                    }}>
                    Modifier
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewTierDialog;
